import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { cn } from '@/utils/cn';

interface NavigationButtonProps {
  onClick: () => void;
  disabled: boolean;
  direction: 'left' | 'right';
}

export const NavigationButton = ({
  onClick,
  disabled,
  direction,
}: NavigationButtonProps) => (
  <button
    className={cn(
      'relative inline-flex items-center px-2 py-2 text-gray-400 hover:bg-light-blue-o15 focus:z-20 focus:outline-offset-0',
      direction === 'left' ? 'rounded-l-md' : 'rounded-r-md'
    )}
    disabled={disabled}
    onClick={onClick}
    type="button"
  >
    <span className="sr-only">
      {direction === 'left' ? 'Previous' : 'Next'}
    </span>
    {direction === 'left' ? (
      <ChevronLeftIcon
        aria-hidden="true"
        className="h-5 w-5 text-light-blue disabled:opacity-50"
      />
    ) : (
      <ChevronRightIcon
        aria-hidden="true"
        className="h-5 w-5 text-light-blue disabled:opacity-50"
      />
    )}
  </button>
);
